import type { CoverageSummary } from "../domain/coverage";

interface CoverageMeterProps {
  coverage: CoverageSummary;
}

export function CoverageMeter({ coverage }: CoverageMeterProps) {
  const { overall, perOperation } = coverage;
  return (
    <div>
      <h3>Cobertura negativa</h3>
      <div
        className="coverage-meter"
        role="meter"
        aria-valuenow={overall.percentage}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label="Cobertura negativa revisada"
      >
        <div className="bar-track">
          <div className="bar-fill" style={{ width: `${overall.percentage}%` }} />
        </div>
        <span className="bar-value">{overall.percentage}%</span>
      </div>
      <p className="field-hint">
        {overall.covered} de {overall.relevant} casos de fallo aceptados fueron revisados y confirmados por
        un humano. Los supuestos del motor no cuentan hasta que se confirman en el editor de cada caso.
      </p>
      <table className="coverage-table">
        <caption>Cobertura por operación (alternativa textual a la barra anterior)</caption>
        <thead>
          <tr>
            <th scope="col">Operación</th>
            <th scope="col">Revisados</th>
            <th scope="col">Relevantes</th>
            <th scope="col">%</th>
          </tr>
        </thead>
        <tbody>
          {perOperation.map((row) => (
            <tr key={row.operationId}>
              <td>
                <code>{row.operationId}</code>
              </td>
              <td>{row.covered}</td>
              <td>{row.relevant}</td>
              <td>{row.percentage}%</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
